<template>
  <div>
    <div class="row">
      <div class="input-field col s12 offset-m1 m10 offset-l3 l6">
        <h3>{{title}}</h3>
      </div>
    </div>
    <div class="row">

      <div class="col s12 offset-m1 m10 offset-l3 l6">
        {{result}}
      </div>

      <div class="col s12 offset-m1 m10 offset-l3 l6" v-if="redirecting">
        Önt hamarosan átirányítjuk.
      </div>

      <div class="col s12 offset-m1 m10 offset-l3 l6" v-if="!success">
        <a v-link="{path: backLink}">Újrapróbálkozás</a>
      </div>

    </div>
  </div>
</template>

<script>
import urlencode from 'urlencode'
import {post} from '../../api'
import {error} from '../../flash-messages'

export default {
  data() {
    const title = (() => {
      switch (this.$route.params.type) {
        case 'sms': return 'Telefonszám aktiválása'
        case 'email': return 'Email cím aktiválása'
        default: return ''
      }
    })()
    return {
      title: title,
      result: 'Aktiválás folyamatban...',
      backLink: '#',
      success: false,
      redirecting: false
    }
  },
  ready() {
    this.init()
  },
  methods: {
    init() {
      const params = this.$route.params
      if (!['email', 'sms'].includes(params.type)) {
        error('Hibás cím!')
        this.$router.go('/')
      }
      return post(`/public/ajax/activate/${params.type}/${params.id}/${params.code}`, {}, () => {
        this.success = true
        this.result = 'Az aktiválás sikeres!'
        const genPass = this.$route.query.genpass
        if (genPass) {
          this.redirecting = true
          setTimeout(function() {
            this.passwordResetRedirect(params.id, genPass)
          }.bind(this), 3000)
        }
      }, {
        error: (xhr, textStatus, errorThrown) => {
          const response = JSON.parse(xhr.responseText)
          this.result = response.message

          const field = params.type === 'email' ? 'email' : 'mobile'
          this.backLink = `/activation-form/?${field}=${params.id}`
        }
      })
    },
    passwordResetRedirect(login, genpass) {
      const loginEncoded = urlencode(login)
      this.$router.go(`/reset-password?user=${loginEncoded}&id=${genpass}`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Activation.vue?cafeabd2